<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const colors = [
  'var(--apex-cyan)',
  'var(--apex-gokarts)',
  'var(--apex-gocontrol)',
  'var(--apex-goracing)',
]

const colorIndex = ref(0)
let colorTimer: ReturnType<typeof setInterval> | null = null

onMounted(() => {
  colorTimer = setInterval(() => {
    colorIndex.value = (colorIndex.value + 1) % colors.length
  }, 1800)
})

onUnmounted(() => {
  if (colorTimer) clearInterval(colorTimer)
})
</script>

<template>
  <div class="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background">
    <p class="app-name">
      <span class="go-slot">
        <span v-for="w in colors" :key="w" class="invisible" aria-hidden="true">Go</span>
        <Transition name="slide-go">
          <span :key="colorIndex" class="go-visible" :style="{ color: colors[colorIndex] }">Go</span>
        </Transition>
      </span><span class="app-name-manager">Manager</span>
    </p>

    <div class="bars">
      <div class="bar bar-1" />
      <div class="bar bar-2" />
      <div class="bar bar-3" />
      <div class="bar bar-4" />
      <div class="bar bar-5" />
    </div>
  </div>
</template>

<style scoped>
.app-name {
  font-family: 'Lato', sans-serif;
  font-size: 24px;
  letter-spacing: 0.3px;
  opacity: 0;
  animation: fade-in 0.5s ease-out 0.2s forwards;
}

.go-slot {
  display: inline-grid;
  vertical-align: baseline;
  overflow: hidden;
}

.go-slot > span {
  grid-area: 1 / 1;
}

.go-visible {
  font-weight: 900;
}

.slide-go-enter-active {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
}
.slide-go-leave-active {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;
}
.slide-go-enter-from {
  transform: translateY(110%);
  opacity: 0;
}
.slide-go-leave-to {
  transform: translateY(-110%);
  opacity: 0;
}

.app-name-manager {
  font-weight: 300;
  color: var(--foreground);
  opacity: 0.5;
}

/* ── Chart bars ── */
.bars {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 24px;
  margin-top: 20px;
  opacity: 0;
  animation: fade-in 0.5s ease-out 0.5s forwards;
}

.bar {
  width: 3px;
  border-radius: 1.5px;
  background: var(--foreground);
  opacity: 0.2;
  animation: bar-pulse 1.2s ease-in-out infinite;
}

.bar-1 { height: 10px; animation-delay: 0s; }
.bar-2 { height: 18px; animation-delay: 0.15s; }
.bar-3 { height: 12px; animation-delay: 0.3s; }
.bar-4 { height: 22px; animation-delay: 0.45s; }
.bar-5 { height: 8px;  animation-delay: 0.6s; }

@keyframes bar-pulse {
  0%, 100% { transform: scaleY(0.4); opacity: 0.15; }
  50%      { transform: scaleY(1);   opacity: 0.3; }
}

@keyframes fade-in {
  0%   { opacity: 0; }
  100% { opacity: 1; }
}
</style>
